export enum booksActionsTypes {
  BOOKS_SEARCHING = "BOOKS_SEARCHING",
  BOOKS_GOT = "BOOKS_GOT",
  COMPETITION_BOOKS_GOT = "COMPETITION_BOOKS_GOT",
  BOOKS_SEARCHING_FAILED = "BOOKS_SEARCHING_FAILED",
  RANDOM_BOOKS_LOADED = "RANDOM_BOOKS_LOADED",
  BOOKS_FROM_FOLDER = "BOOKS_FROM_FOLDER",
  TOP_BOOKS_GOT = "TOP_BOOKS_GOT",
}
